import { get } from "lodash";

export function getAuthorPath(author = {}) {
  const authorSlug = get(author, ["slug"], "");
  if (!authorSlug) return null;
  return "/author/" + authorSlug;
}
